import React from 'react';
import { getPublicAvatarUrlForUser } from '../../utils/avatarUtils';
import { getAccountAvatarPlaceholderVariant } from '../../utils/accountAvatarStatus';
import { AccountAvatarPlaceholder } from './AccountAvatarPlaceholder';

/**
 * Awatar użytkownika w listach (znajomi, udostępnianie itd.) — jedna ścieżka dla kont nieaktywnych / zbanowanych.
 */
export function UserListAvatar({
  user,
  size = 100,
  /** Klasa na `<img>` lub na wrapper `<div>` przy placeholderze / fallbacku */
  className = '',
  /** Dodatkowa klasa na wrapper (np. gradient „brak zdjęcia”) */
  variantWrapperClassName = '',
  inactiveTitle,
  bannedTitle,
  /** Treść gdy konto aktywne, ale brak `avatar_url` (np. inicjały) */
  fallback = null,
  alt = '',
}) {
  const url = getPublicAvatarUrlForUser(user, size);
  const variant = getAccountAvatarPlaceholderVariant(user);
  const blockClass = [className, variantWrapperClassName].filter(Boolean).join(' ');

  if (url) {
    return <img src={url} alt={alt} className={className} />;
  }

  if (variant) {
    const title = variant === 'banned' ? bannedTitle : inactiveTitle;
    return (
      <div className={blockClass}>
        <AccountAvatarPlaceholder variant={variant} title={title} />
      </div>
    );
  }

  if (fallback != null && fallback !== '') {
    return (
      <div className={blockClass}>
        {typeof fallback === 'string' || typeof fallback === 'number' ? (
          <span aria-hidden>{fallback}</span>
        ) : (
          fallback
        )}
      </div>
    );
  }

  return <div className={blockClass} aria-hidden />;
}
